var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({staticClass:"form-button",class:_vm.type,on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false),[_c('div',[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }